module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-900.48cd900f.svg";